import { useRequiredContext } from "@redotech/react-util/context";
import HomeIcon from "@redotech/redo-icons/home-02.svg";
import HomeFilledIcon from "@redotech/redo-icons/home-02_filled.svg";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { LinkPrimaryTab } from "@redotech/redo-web/arbiter-components/navigation/primary/redo-primary-nav";
import { PageNavigationEntry } from "@redotech/redo-web/arbiter-components/navigation/redo-side-navigation";
import { SecondaryNavigationData } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav";
import {
  RedoSecondaryNavItem,
  useNavTreeNode,
} from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo, useContext } from "react";
import { NavigationVersionContext } from "../../navigation-version-context";

export function useHomeNavigation(): PageNavigationEntry | null {
  const routes = useRequiredContext(MerchantRoutesContext);
  const { newNavigationEnabled } = useContext(NavigationVersionContext);

  const primaryTab: LinkPrimaryTab = {
    id: "home",
    hasNotification: false,
    UnfilledIcon: HomeIcon,
    FilledIcon: HomeFilledIcon,
    type: "link",
    href: routes.homeBaseHref,
    pathRoot: routes.homeBaseHref,
    friendlyName: "Home",
  };

  // New navigation drops the Home secondary panel (icon-only tab).
  // Legacy navigation keeps the "Overview" secondary nav item.
  if (newNavigationEnabled) {
    return { primaryTab, secondaryNavigationData: undefined };
  }

  const secondaryNavigationData: SecondaryNavigationData = {
    id: "home",
    name: "Home",
    NavContent: SecondaryHomeNavigation,
  };

  return { primaryTab, secondaryNavigationData };
}

const SecondaryHomeNavigation = memo(function SecondaryHomeNavigation() {
  const routes = useRequiredContext(MerchantRoutesContext);

  const { id: nodeId, TreeContext } = useNavTreeNode({ friendlyName: "Home" });

  return (
    <TreeContext.Provider value={nodeId}>
      <RedoSecondaryNavItem
        action={{ type: "link", href: routes.overviewHref }}
        FilledIcon={HomeFilledIcon}
        friendlyName="Overview"
        id="overview"
        UnfilledIcon={HomeIcon}
      />
    </TreeContext.Provider>
  );
});
